<ng-container *ngIf="!config.isCxOne">
    <mat-form-field class="cv-material-control flex-fill" [class.cv-auto-width]="autoWidth" appearance="fill" *ngIf="categoryModel">
        <mat-select
            [attr.id]="(pageName + 'attributeSelector-Select-' + attributeType + '-' + categoryModel.SelectedCategoryID) | cleanId"
            class="flex-fill my-auto w-100 lato-regular"
            panelClass="cv-material-control"
            [value]="categoryModel.SelectedAttributeIDs"
            [disabled]="!values"
            (openedChange)="$event ? onSelectorOpen() : onSelectorClose()"
            [multiple]="true"
            [placeholder]="'Select'"
            [disableRipple]="true"
            [attr.category-id]="categoryModel.SelectedCategoryID"
        >
            <mat-select-trigger *ngIf="allSelected">
                <span cvLocalizedText langSection="Common" langKey="All"></span>
            </mat-select-trigger>
            <div class="search-box live-search">
                <input type="search" class="form-control form-control-lg" placeholder="Search" [(ngModel)]="filter" maxlength="50" onkeydown="event.stopPropagation()" />
                <span class="clear-input" [hidden]="!filter" (click)="filter = ''"></span>
            </div>
            <mat-option [attr.id]="(pageName + 'attributeSelector-Select-' + attributeType + '-' + categoryModel.SelectedCategoryID + '-All') | cleanId" [value]="-1" (click)="onSelectAllToggled()" >
                <span cv-localized-text lang-section="Common" lang-key="All">All</span>
            </mat-option>
            <mat-option [value]="0" [attr.id]="(pageName + 'attributeSelector-Select-' + attributeType + '-' + categoryModel.SelectedCategoryID + '-NotSet') | cleanId" (onSelectionChange)="onSelectedAttributeValueChanged($event)" [hidden]="filter && !service.localizationText.notSet.toLowerCase().includes(filter.toLowerCase())">
                {{ service.localizationText.notSet }}
            </mat-option>
            <mat-option *ngFor="let value of (values | filterText: filter : 'Name')" [value]="value.ID" [attr.category-id]="categoryModel.SelectedCategoryID" (onSelectionChange)="onSelectedAttributeValueChanged($event)">
                {{ value.Name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <select class="form-control" *ngIf="!categoryModel">
        <option selected *ngIf="categoryModel === null">Attribute not found</option>
    </select>
</ng-container>

<ng-container *ngIf="config.isCxOne">
    <cxone-multiselect-dropdown class="w-100" [selection]="cxValues" (selectionChanged)="onCXSelectionChanged($event)" (dropdownOpened)="onSelectorOpen()" 
                (dropdownClosed)="onCXSelectorClose()" [options]="cxOptions" [label]="'name'" [primaryKey]="'id'" [sortOrder]="'asc'" [sortKey]="'id'"
                [isLoading]="categoryModel === null || !cxOptions?.length" [isRequired]="false" [maxItemsToDisplay]="1000">
    </cxone-multiselect-dropdown>
</ng-container>